import { z } from "zod";

import { documentChangesForAgentSchema, type DocumentChangesForAgent } from "./document-changes-for-agent";

export const UserViewSchema = z.object({
  user_channel: z.string(),
  user_page: z.string(),
  open_widgets: z.array(z.string()),
});

export const OfficeHostSchema = z.object({
  platform: z.string(),
  version: z.string(),
});

export const ClientContextSchema = z.object({
  user_view: UserViewSchema,
  office_host: OfficeHostSchema.optional(),
});

export const FocusedDocumentAttachmentSchema = z.object({
  file_name: z.string(),
  docx_base64: z.string(),
});

export type UserView = z.infer<typeof UserViewSchema>;
export type OfficeHost = z.infer<typeof OfficeHostSchema>;
export type ClientContext = z.infer<typeof ClientContextSchema>;
export type FocusedDocumentAttachment = z.infer<typeof FocusedDocumentAttachmentSchema>;

export const AgentChatRequestSchema = z.object({
  message: z.string(),
  conversation_id: z.string(),
  model_name: z.string(),
  user_agent: z.string(),
  client_context: ClientContextSchema,
  skills: z.array(z.string()).optional(),
  selected_text_snippet: z.string().nullish(),
  focused_document: FocusedDocumentAttachmentSchema.optional(),
  document_changes: documentChangesForAgentSchema.optional(),
  agent_instructions: z.string().optional(),
  mode: z.string().nullable(),
  author: z.string().nullable(),
}).strict();

export type AgentChatRequest = z.infer<typeof AgentChatRequestSchema>;

export interface AgentChatRequestInput {
  message: string;
  conversationId: string;
  modelName: string;
  userAgent: string;
  clientContext: ClientContext;
  skills?: string[];
  selectedTextSnippet?: string | null;
  focusedDocument?: FocusedDocumentAttachment;
  documentChanges?: DocumentChangesForAgent;
  agentInstructions?: string;
  mode: string | null;
  author: string | null;
}

export function serializeAgentChatRequest(input: AgentChatRequestInput): string {
  return JSON.stringify(AgentChatRequestSchema.parse({
    message: input.message,
    conversation_id: input.conversationId,
    model_name: input.modelName,
    user_agent: input.userAgent,
    client_context: input.clientContext,
    skills: input.skills?.length ? input.skills : undefined,
    selected_text_snippet: input.selectedTextSnippet,
    focused_document: input.focusedDocument,
    document_changes: input.documentChanges,
    agent_instructions: input.agentInstructions || undefined,
    mode: input.mode,
    author: input.author,
  }));
}
